import { Component, OnInit } from '@angular/core';
import { TemplateService } from '../../services/template.service';
import { IPage } from '../../model/page';
import { UntypedFormGroup, UntypedFormBuilder , Validators, UntypedFormControl} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ReturnStatement } from '@angular/compiler';
import { Observable, Subject, Subscription, timer } from 'rxjs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { formControlBinding } from '@angular/forms/src/directives/ng_model';
// import { validateConfig } from '@angular/router/src/config';
declare var $: any;

@Component({
    selector: 'app-template',
    templateUrl: './template.component.html',
    styleUrls: ['./template.component.scss'],
    standalone: false
})
export class TemplateComponent implements OnInit {
  page: IPage;
  name: any;
  status: any;
  showloader = true;
  successful_result = false;
  error_result = false;
  dropdownList = [];
  dropdownSettings: {};
  form: UntypedFormGroup;
  title: string;
  submitted = false;
  post_results: string;
  private subscription: Subscription;
  private timer: Observable<any>;
  crumbList: any = [];
  // editor: any;

  public options: Object = {
    key: 'HQD1uB5B3C1A1D2E2B4E1FvfxjF1QUg1Xc2OZE1ABVJRDRNGGUH1ITrA1C7A6C5E1E4H4E1A9A8==',
    // key: 'dC10B5D5A2A-9H3E2J2A4C6C3C2B5B1E1pj1wgbrD-11fzfsB-22B3zuv==',
    // key: 'eHE5C-11B2C1F2I2A5C4D-17d1F1FOOLb2KOPQGe1CWCQVTDWXGcA5A4D4D3E4C2G2E3C1B2==',
    attribution: false,
  };
  public templateContent = '';

  constructor(
    private http: HttpClient,
    private templateSer: TemplateService,
    private fb: UntypedFormBuilder,
    private actRoute: ActivatedRoute,
    private router: Router ) {

      this.showloader = true;
  }

  ngOnInit() {
    this.showloader = true;
    this.crumbList = [
      { title: 'Home', url: '/dashboard' },
      { title: 'Admin Menu', url: '/admins/admin-menu' },
      { title: 'Template List', url: '/admins/template-list' }
    ];

    this.form = this.fb.group({
      Template: new UntypedFormControl()
    });
    this.actRoute.params.subscribe( params =>
      this.name = params['name']
    );
    this.title = 'Edit Template';
    this.templateSer.getTemplate(this.name).subscribe((data: any) => {
       const templateSt = this.convertToString( data.Template );
       this.form.patchValue({
           Template: templateSt
       });
       this.showloader = false;
       this.templateContent = templateSt;
    });

    const userData = localStorage.getItem('UserData');
  }

  updateText() {
    console.log( 'made it' );
  }
  convertToString( arr: any[] ) {
    let result = '';
    for (var idx = 0; idx < arr.length; idx++ ) {
      result += arr[idx];
    }
    return result;
  }

  savePage() {
    // this.submitted = true;
    this.showloader = true;
    this.submitted = true;

    // stop here if form is invalid
    if (this.form.invalid) {
      this.showloader = false;
      return;
    }

    if (this.form.valid) {
      const fd = new FormData();

      fd.append('Name', this.name);
      fd.append('Template', this.templateContent );

      this.templateSer.saveTemplate(this.name, fd ).subscribe((res: any) => {
        if (res) {
            this.successful_result = true;
        } else {
          this.error_result = true;
          console.log('unable to save');
        }
        this.setTimer();
      });

      this.showloader = false;
      this.submitted = false;
    }
  }

  public setTimer() {
    this.timer = timer(2500);
    this.subscription = this.timer.subscribe(() => {
        this.successful_result = false;
        this.error_result = false;
    });
  }

  toggleChange(event: any) {
    this.status = (event.target.checked ? 'Yes' : 'No');
  }

}
